import {ReplaySubject, distinct} from "../observable/ReplaySubject";


export class PdqHotkeyService {
    #showPdqData = new ReplaySubject<boolean>(1)
    showPdqData = distinct(this.#showPdqData)

    constructor() {
        let toggled = false;
        document.addEventListener('keydown', (e) => {
            if (e.altKey) {
                this.#showPdqData.next(true)
            }
            if (e.altKey && e.ctrlKey) {
                toggled = !toggled;
            }
        })
        document.addEventListener('keyup', (e) => {
            if (!toggled)
                this.#showPdqData.next(false)
        })
    }

}

export const pdqHotkeyService = new PdqHotkeyService();
export default pdqHotkeyService;